import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import WorkOSVerifyModal from "./WorkOSVerifyModal";
      function DiamondBorder() {
  return (

      



         <svg
            viewBox="0 0 400 240"
             style={{
             position: "absolute",
             width: "100%",
             height: "100%"
      }}
    >
      <defs>
        <linearGradient id="rainbow" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ff0000" />
          <stop offset="20%" stopColor="#ff9900" />
          <stop offset="40%" stopColor="#ffff00" />
          <stop offset="60%" stopColor="#00ff99" />
          <stop offset="80%" stopColor="#0099ff" />
          <stop offset="100%" stopColor="#cc00ff" />
        </linearGradient>
      </defs>

      <polygon
              points="60,20 340,20 380,90 200,220 20,90"
              fill="none"
              stroke="url(#rainbow)"
              strokeWidth="3"
      />
    </svg>
  );
}

          export default function SignIn() {
     const [username, setUsername] = useState("");
     const [password, setPassword] = useState("");
     const [showWorkOSModal, setShowWorkOSModal] = useState(false);

     const navigate = useNavigate();
     const { login } = useAuth();

     const handleSubmit = async (e) => {
        e.preventDefault();

  try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        password
      }),
    });

    const data = await response.json();
    if (!response.ok) {
      alert(data.error);
      return;
    }

    
     login({
       username: data.username,
       account_id: data.alpacaAccountId
   });

    localStorage.setItem("spectraToken", data.token);

    // If the user never submitted trading account info, send them back to
    // the onboarding Dashboard so they can complete it.
    if (data.alpacaStatus === "NONE") {
      setTimeout(() => {
        navigate("/Dashboard");
      }, 200);
    } else {
      // Account is ACTIVE — redirect to the portfolio tracker. Only a short-lived,
      // single-use handoff code travels in the URL; portfolio-tracker exchanges it
      // server-side for the real session token so the token itself never appears
      // in the URL, browser history, or proxy/CDN logs.
      setTimeout(() => {
        window.location.href = `${process.env.REACT_APP_PORTFOLIO_URL}/?handoff=${data.handoffCode}`;
      }, 200);
    }


        } catch (err) {
             console.error(err);
             alert("Server error");
      }
    };

     const pageWrapper = {
               minHeight: "100vh",
               display: "flex",
               flexDirection: "column",
               alignItems: "center",
               justifyContent: "center",
               background: "#f2f7ff"
  };

     const titleStyle = {
               fontSize: 26,
               fontWeight: 600,
               marginBottom: 16
  };

     const subtitleStyle = {
                marginBottom: 20,
                color: "#666",
                textAlign: "center",
                maxWidth: 480
  };

      const diamondContainer = {
                position: "relative",
                width: 660,
                height: 560
  };

      const formPosition = {
                position: "absolute",
                top: "40%",
                left: "50%",
                transform: "translate(-50%, -40%)",
                width: 200,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
   };
     return (
    <div style={pageWrapper}>
      {showWorkOSModal && (
        <WorkOSVerifyModal
          initialUsername={username}
          onClose={() => setShowWorkOSModal(false)}
        />
      )}

      <h2 style={titleStyle}> Log In</h2>
      <p style={subtitleStyle}>
        Enter Exhisting Username and password to log into Your Spectra Market Analyzer Trading Account.
      </p>

      <button
        type="button"
        onClick={() => setShowWorkOSModal(true)}
        style={{
          position: "relative",
          top: 14,
          marginBottom: 14,
          padding: "7px 18px",
          borderRadius: 6,
          border: "1px solid #00bfff",
          background: "transparent",
          color: "#00bfff",
          fontWeight: 600,
          cursor: "pointer",
          fontSize: 13,
        }}
      >
        MFA / Lost Password
      </button>

      <div style={diamondContainer}>
        <DiamondBorder />

        <form onSubmit={handleSubmit} style={formPosition}>
          <div style={{ marginTop: 12 }}>
            <input
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                boxSizing: "border-box"
              }}
            />
          </div>

          <div style={{ marginTop: 16 }}>
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                boxSizing: "border-box"
              }}
            />
          </div>

          
            <button
                type="submit"
                style={{
                marginTop: 20,
                padding: "12px",
                borderRadius: "9px",
                background: "#00bfff",
                border: "none",
                color: "#fff",
                fontWeight: 600,
                width: "280",
                boxSizing: "border-box",  // ← ADD THIS
                cursor: "pointer"
          }}
         >
            Sign In
          </button>
          </form>
      </div>
    </div>
  );
}